import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonPage, IonRow, IonText, IonTitle } from '@ionic/react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { RouteComponentProps } from 'react-router';
import { AsyncAutocomplete, Header } from '../../components';

import './Calculator.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/store';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

interface ArticleSearchForm {
  article: string | null
}

const CalculatorOverview: React.FC<RouteComponentProps> = ({ history }: RouteComponentProps) => {
  const darkMode: boolean = useSelector((state: RootState) => state.user.darkMode);
  const { control, handleSubmit, formState: { errors } } = useForm<ArticleSearchForm>({
    mode: "onTouched",
    reValidateMode: "onChange",
  });
  const { t } = useTranslation();

  const onSubmit: SubmitHandler<ArticleSearchForm> = data => {
    //console.log(data.article?.split(" ").join(""))
    if (data.article) {
      history.push(`/tabs/calculator/preselection/sku1=${data.article.split(" ").join("")}`)
    }
  }

  return (
    <IonPage>
      <Header>
        <IonTitle>{t("calculator.Schnittwerte")}</IonTitle>
      </Header>
      <IonContent fullscreen>
        <IonGrid fixed={true} className="mainContent">
          <IonRow>
            <IonCol size="12">
              {/* Calculator */}
              <IonCard style={{ marginTop: 20 }}>
                <IonCardHeader>
                  <IonCardTitle>
                  {t("Kalkulator")}
                  </IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <div className='calculatorCardContainer'>
                    <IonText>{t("calculator.Sie suchen Schnittwerte für eine Anwendung mit unserem Fräser")}:</IonText>
                    <div className='calculatorImageContainer'>
                      <img className="calculatorImage" alt={t("calculator.CNC Maschine mit Handy auf dem der Kalkulator geöffnet ist")} src={darkMode ? `/assets/images/languageSpecific/${i18n.language}/cnc_dark.png` : `/assets/images/languageSpecific/${i18n.language}/cnc_light.png`} />
                    </div>
                  </div>

                  <IonButton style={{ marginTop: 16 }} expand='block' routerLink='/tabs/calculator/form'>{t("calculator.zum Kalkulator")}</IonButton>
                </IonCardContent>
              </IonCard>
            </IonCol>


            {/* Standard Schnittwerte */}
            <IonCol size="12">
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>
                    {t("calculator.Richtwerte für Ihren Fräser")}
                  </IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonText>{t("calculator.Sie suchen Schnittwerte für einen bestimmten Hachenbach-Fräser")}:</IonText>
                  <form>
                    <Controller
                      render={({ field: { onChange, onBlur, value } }) => (
                        <AsyncAutocomplete
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                        />
                      )}
                      control={control}
                      name="article"
                      defaultValue={null}
                      rules={{
                        required: { value: true, message: t("Feld darf nicht leer sein") },
                      }}
                    />
                    {/* @ts-ignore */}
                    {errors.ident && <div style={{ textAlign: "left", color: "#eb445a", fontSize: 14 }}>{errors.ident.message}</div>}
                    <IonButton style={{ marginTop: 16 }} onClick={handleSubmit(onSubmit)} expand="block">{t("calculator.Suchen")}</IonButton>
                  </form>
                </IonCardContent>
              </IonCard>
            </IonCol>

          </IonRow>
        </IonGrid>

      </IonContent>
    </IonPage>
  );
};

export default CalculatorOverview;
